export default [
  {
    name: '发票订单',
    path: '/kids/invoice',
    component: () => import('@/views/kids/invoice/InvoiceList.vue'),
  },
  {
    name: '发票详情',
    path: '/kids/invoice/apply',
    component: () => import('@/views/kids/invoice/InvoiceApply.vue'),
  },
];
